import { makeStyles } from '@material-ui/core/styles';
import QueryTableRefresh from 'components-lib/QueryTable/QueryTableRefresh';
import Button from "components/CustomButtons/Button.js";
import paths from 'paths';
import React, { useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { generatePath } from 'react-router-dom';
import styles from "common/styles/widgets.js";
import Box from "@material-ui/core/Box";
import CheckIcon from '@material-ui/icons/Check';
import moment from "moment";
import { colors, } from 'common/styles/configLayout';
// import MEMBER_LICENSE_REQUEST_CONFIRM from 'queries/LicensesQueries/memberLicenseRequestConfirm'
import { useMutation } from '@apollo/client';
import { useSnackbar } from 'notistack';
import { connect } from 'react-redux';
import { changeLicensesNumberAction } from 'redux/actions';
import MEMBER_LICENSE_REQUESTS_TABLE from 'queries/LicensesQueries/memberLicenseRequestsTable';
import { getApolloClient } from "configFiles/apollo";
import Tooltip from '@material-ui/core/Tooltip';
import StatusTextField from "components-lib/StatusTextField/StatusTextField";
import RoleEnum from "common/enums/RoleEnum";
import { pathOr } from 'rambda';

const useStyles = makeStyles((theme) => styles(theme))

export const MemberLicensesTable = (props) => {
    const { 
        intl, 
        history,
        data, 
        loadData,
        refetch, 
        numberOfRows, 
        queryDataPath, 
        defaultFilter = null, 
        queryVariables, 
        role,
        changeTab,
        setChangeTab,
        downloadLicenses,
        rowData,
        setRowData,
     } = props
    const classes = useStyles();
    const { enqueueSnackbar } = useSnackbar();
    const client = getApolloClient(enqueueSnackbar, history, intl);

    return (
        <>
            <QueryTableRefresh
                nameTable={`${paths.licenses.list}/licensesTable`}
                data={data}
                loadData={loadData}
                numberOfRows={numberOfRows}
                permanentFilter={defaultFilter}
                queryDataPath={queryDataPath}
                queryVariables={queryVariables}
                setChangeTab={setChangeTab}
                changeTab={changeTab}
                rowData={rowData}
                setRowData={setRowData}
                downloadLicenses={downloadLicenses}
                smallTable={10}
                columnsWidth={['auto', 'auto', 'auto', 'auto', 'auto', 'auto']}
                columns={[
                    {
                        Header: "UCI ID",
                        accessor: 'uciId',
                        sortKey: 'uciId',
                        filterKey: 'uciId',
                        filterOperator: 'contains',
                        minWidth: '100px',
                        maxWidth: '165px',
                    },
                    {
                        Header: "Člen",
                        accessor: "member",
                        sortKey: 'member',
                        filterKey: 'member',
                        filterOperator: 'contains',
                        minWidth: '100px',
                        maxWidth: '100%'
                    },
                    {
                        Header: "Klub",
                        accessor: "club",
                        sortKey: "club",
                        filterKey: 'club',
                        filterOperator: 'contains',
                        minWidth: '100px',
                        maxWidth: '100%'
                    },
                    {
                        Header: "Funkcia",
                        accessor: "function",
                        sortKey: "function",
                        filterKey: 'function',
                        filterOperator: 'contains',
                        minWidth: '100px',
                        maxWidth: '100%'
                    },
                    {
                        Header: "Rok",
                        accessor: 'year',
                        sortKey: 'year',
                        filterKey: 'year',
                        filterOperator: 'contains',
                        minWidth: '100px',
                        maxWidth: '108px',
                    },
                    {
                        Header: "Kategória",
                        accessor: 'categories',
                        sortKey: 'categories',
                        filterKey: 'categories',
                        filterOperator: 'contains',
                        minWidth: '110px',
                        maxWidth: '165px',
                    },
                    // {
                    //     Header: ' ',
                    //     filterKey: "actions",
                    //     accessor: (rowData) =>
                    //         <Box className={classes.floatRight}>
                    //             {/* {role === RoleEnum.ADMIN && <>
                    //                 {(rowData.status === "Downloaded") && <Tooltip title={"Označiť ako vytlačené"}><CheckIcon className={classes.circle} onClick={() => handleConfirmLicense(rowData.id)} /></Tooltip>}
                    //             </>}
                    //             <Button round size="sm" color="info" table onClick={() => onLicenseDetail(rowData.id)}>Detail</Button> */}
                    //         </Box>,
                    //     minWidth: '60px',
                    //     maxWidth: '150px'
                    // }
                ]}
            />
        </>

    )
}

const mapStateToProps = (state) => ({
    role: state.role,
});


const mapDispatchToProps = (dispatch) => ({
    changeLicensesNumberAction: (value) => dispatch(changeLicensesNumberAction(value)),
});


export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(MemberLicensesTable));
